import { useMutateOnRefresh } from '@va/dashboard/util-hooks';
import { useNumberOfVisitorsByMonth } from './apiClient';
import TrafficChartCard from './TrafficChartCard';

const VisitorsByMonthChart = () => {
  const { data, isLoading, mutate } = useNumberOfVisitorsByMonth();
  const { isManualRefreshing } = useMutateOnRefresh(mutate);
  return <TrafficChartCard baseKey='trafficVisitorsByMonth' isLoading={isLoading || isManualRefreshing} data={data!} />;
};

export default VisitorsByMonthChart;
